import * as Apollo from '@apollo/client'
import {GQL_AllBoxLocationsLiteQuery, GQL_AllBoxLocationsLiteQueryVariables, useAllBoxLocationsLiteQuery} from '../../../generated/graphql'

export interface BoxLocationLite {
  municipality?: string | null
  locality?: string | null
}

export const useAllBoxLocationsLite = (
  baseOptions?: Apollo.QueryHookOptions<GQL_AllBoxLocationsLiteQuery, GQL_AllBoxLocationsLiteQueryVariables>,
) => {
  const {data, ...rest} = useAllBoxLocationsLiteQuery(baseOptions)
  const locations: BoxLocationLite[] = data?.box?.allBoxes.map((b) => b.location) ?? []
  return {...rest, data: locations}
}
